var ko = require('knockout');
var _ = require('underscore');

// Bind an observable to the hover state of an element. The observable
// will be set to true when the element is hovered over and false when
// it's not.
//
// Examples
//
//    data-bind="drag: opaqueId"
//
var drag = {
  init: function(element, valueAccessor) {
    var $element = $(element);
    var value = valueAccessor();

    $element.attr('draggable', true);

    $element.bind('dragstart', function(e) {
      drag.payload = value;
    });
  }
};

// Bind a method (or methods) to fire when an element has a dragged element
// dropped on it. This is meant to be used in conjunction with the drag binding.
// The method will be called with the payload from the associated drag event
// as the first argument, but you can add optional extra arguments as well.
// You can also configure a separate method for a drop on the left or right
// half of an element. If you are calling a method on a different viewModel
// than the current level (like when using $parent or $root), you can indicate
// which viewmodel object to call the methods on.
//
// Examples
//
//   data-bind="drop: removeOpaqueId"
//
//   data-bind="drop: { call: removeOpaqueIdAndName,
//                      extraArgs: [name] }"
//
//   data-bind="drop: { left: addOpaqueIdBefore, right: addOpaqueIdAfter,
//                      extraArgs: [opaqueId] }"
//
//   data-bind="drop: { left: $parent.addOpaqueIdBefore,
//                      right: $parent.addOpaqueIdAfter,
//                      viewModel: $parent }"
//
var drop = {
  init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
    var $element = $(element);
    var value = valueAccessor();
    var callback, callbackLeft, callbackRight, extraArgs = [];

    if (_.isObject(value) && !_.isFunction(value) && !ko.isObservable(value)) {
      callback = value['call'];
      callbackLeft = value['left'];
      callbackRight = value['right'];
      extraArgs = value['extraArgs'];
      if (value['viewModel']) viewModel = value['viewModel'];
    } else {
      callback = value;
    }

    $element.bind('drop', function(e) {
      e.stopPropagation();

      var args = ko.utils.unwrapObservable(extraArgs);
      args = _.map(args, ko.utils.unwrapObservable);
      args.unshift(ko.utils.unwrapObservable(drag.payload));

      if (callback) {
        callback.apply(viewModel, args);
      } else {
        if (isOnRight($element, e.originalEvent.pageX, e.originalEvent.pageY)) {
          if (callbackRight) callbackRight.apply(viewModel, args);
        } else {
          if (callbackLeft) callbackLeft.apply(viewModel, args);
        }
      }
    });

    $element.bind('dragover', function(e) {
      // Must cancel the default in order to allow dropping
      e.preventDefault();
      return false;
    });
  }
};

// Helper method to determine if an event happens on the right or left side
// of an element.
function isOnRight($element, pageX, pageY) {
  var offset = $element.offset();
  var width = $element.outerWidth(true);
  return pageX > offset.left + width / 2;
}

module.exports = {
  drag: drag,
  drop: drop
};
